<template>
  <div class="password-reset-wrapper">
    <div class="password-reset-page container">
      <div class="login-header">
        <div class="logo">
          <img src="@/assets/logo.svg" />
        </div>
        <div class="tiles">
          <span class="tile back-olive"></span>
          <span class="tile back-black"></span>
          <span class="tile back-green"></span>
          <span class="tile back-off-green"></span>
        </div>
      </div>

      <div class="container px-4">
        <h1 class="is-size-1 mr-5">{{ $t("password-reset.title") }}</h1>
        <div v-if="!sent">
          <p class="mb-4">{{ $t("password-reset.description.text") }}</p>
          <form action="#" method="post" @submit.prevent="submit">
            <div class="field mb-4">
              <div class="control">
                <label>{{ $t("login.labels.vat_number") }}</label>
                <input
                  v-model="vatNumber"
                  class="input"
                  type="text"
                  required
                  :placeholder="$t('login.placeholder.vat_number')"
                  autofocus
                />
                <ul v-if="errors.vat_number" class="help is-warning mt-2">
                  <li v-for="(error, index) in errors.vat_number" :key="index">
                    {{ error }}
                  </li>
                </ul>
              </div>
            </div>

            <span
              v-if="errors['non_field_errors']"
              class="has-text-warning has-text-weight-semibold"
            >
              {{ errors["non_field_errors"][0] }}
            </span>

            <button type="submit" class="button is-fullwidth">
              {{ $t("password-reset.submit.label") }}
            </button>
          </form>
        </div>
        <div v-if="sent">
          <p>{{ $t("login.password.sms_sent") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api"
import { mapMutations } from "vuex"

export default {
  name: "password-reset",
  data() {
    return {
      vatNumber: "",
      errors: {},
      result: {},
      sent: false,
    }
  },
  methods: {
    ...mapMutations(["windowOpen"]),
    submit: async function () {
      this.errors = {}
      api
        .requestPasswordReset(this.vatNumber)
        .then((response) => {
          this.result = response.data
          this.sent = true
        })
        .catch((error) => {
          this.errors = error.response ? error.response.data : {}
        })
    },
  },
}
</script>
